// extracted by mini-css-extract-plugin
export default {"error_mssage":"styles_error_mssage__uJmAG","status":"styles_status__1G+z+","colorNumber":"styles_colorNumber__9RuQ3","message":"styles_message__Jk4HH"};